var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { action, reaction } from 'mobx';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useControllers } from '../../hooks/controller.hooks';
import { useOnMount } from '../../hooks/lifecycle.hooks';
import { useProps, useStore } from '../../utils/mobx.utils';
import tick from '../../utils/waiters.utils';
import './BasePagination.scss';
var BasePagination = function (props) {
    var p = useProps(props);
    var UI = useControllers().UI;
    var s = useStore(function () { return ({
        defaultPaginationState: {
            currentPage: 1,
            lastPage: 1,
            numberOfTotalItems: 0,
        },
        get paginationState() {
            return p.paginationState || s.defaultPaginationState;
        },
        get currentPage() {
            return s.paginationState.currentPage;
        },
        set currentPage(n) {
            s.paginationState.currentPage = n;
        },
        get lastPage() {
            return s.paginationState.lastPage;
        },
        set lastPage(n) {
            s.paginationState.lastPage = n;
        },
        get numberOfTotalItems() {
            return s.paginationState.totalItems;
        },
        set numberOfTotalItems(n) {
            s.paginationState.totalItems = n;
        },
        get shouldDisplaySelf() {
            return s.lastPage > 1;
        },
        get numberOfLinksPerSection() {
            switch (UI.displayMode) {
                case 'phone': return 3;
                case 'tablet': return 4;
                default: return 5;
            }
        },
        get visiblePageLinks() {
            if (s.lastPage < 15) {
                return Array(s.lastPage).fill(null).map(function (n, i) { return i + 1; });
            }
            var firstFewLinks = Array(s.numberOfLinksPerSection).fill(null).map(function (n, i) { return i + 1; });
            var lastFewLinks = Array(s.numberOfLinksPerSection).fill(null).map(function (n, i) { return s.lastPage - i; }).reverse();
            var linksNearCurrentPage = Array(Math.floor(s.numberOfLinksPerSection / 2) * 2 + 1).fill(null).map(function (n, i, arr) {
                var halfLength = arr.length / 2;
                if (i < halfLength)
                    return s.currentPage - Math.floor(halfLength - i);
                if (i > halfLength)
                    return s.currentPage + Math.ceil(i - halfLength);
                return s.currentPage;
            });
            var allLinks = Array.from(new Set(__spreadArray(__spreadArray(__spreadArray([], firstFewLinks, true), linksNearCurrentPage, true), lastFewLinks, true))).filter(function (n) { return n > 0 && n <= s.lastPage; }).sort(function (a, b) { return a - b; });
            return allLinks.reduce(function (a, b, i, arr) { return __spreadArray(__spreadArray([], a, true), [
                b - arr[i - 1] > 1 ? '…' : false,
                b
            ], false).filter(function (i) { return i; }); }, []);
        },
        goToPageNumber: action(function (n) {
            if (n === '…')
                return;
            s.currentPage = n;
            p.onChange && p.onChange(n);
        }),
        get prevLabel() {
            switch (UI.displayMode) {
                case 'phone': return 'Prev';
                case 'tablet': return 'Previous';
                default: return 'Previous Page';
            }
        },
        get nextLabel() {
            switch (UI.displayMode) {
                case 'phone': return 'Next';
                case 'tablet': return 'Next';
                default: return 'Next Page';
            }
        },
        get canGoPrev() { return s.currentPage > 1; },
        get canGoNext() { return s.currentPage < s.lastPage; },
        goPrev: function () { return s.goToPageNumber(s.currentPage - 1); },
        goNext: function () { return s.goToPageNumber(s.currentPage + 1); },
        handleButtonClick: function (n) { return function () { return s.goToPageNumber(n); }; },
    }); });
    useOnMount(function () {
        (function readStateFromUrl() {
            return __awaiter(this, void 0, void 0, function () {
                var params, currentPageFromUrl;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, tick()];
                        case 1:
                            _a.sent();
                            if (s.paginationState.doNotSyncWithURL)
                                return [2 /*return*/];
                            params = new URLSearchParams(location.search);
                            currentPageFromUrl = params.get('page');
                            if (currentPageFromUrl) {
                                s.goToPageNumber(parseInt(currentPageFromUrl));
                            }
                            return [2 /*return*/];
                    }
                });
            });
        })();
        var d = [];
        d.push(reaction(function () { return s.paginationState.currentPage > s.paginationState.lastPage; }, function (value) {
            if (value)
                s.goToPageNumber(1);
        }, { fireImmediately: true }));
        return d.forEach(function (f) { return f(); });
    });
    return React.createElement(Observer, { children: function () { return (s.shouldDisplaySelf ? React.createElement("div", { className: "BasePagination" },
            React.createElement("button", { className: "BasePaginationPrevButton", onClick: s.goPrev, disabled: !s.canGoPrev }, s.prevLabel),
            React.createElement("div", { className: "BasePaginationPageList" }, s.visiblePageLinks.map(function (n, i) { return React.createElement("button", { onClick: s.handleButtonClick(n), "data-for-page": n, key: '' + n + i, className: n === s.currentPage ? 'active' : undefined, disabled: n === '…', children: n }); })),
            React.createElement("button", { className: "BasePaginationNextButton", onClick: s.goNext, disabled: !s.canGoNext }, s.nextLabel)) : React.createElement(React.Fragment, null)); } });
};
export default BasePagination;
